import axios from "axios";
import { normalizePrivacyStatus } from "@/Utile/ncrmPrivacyStatus.mjs";
import { serializeContactsAdvancedFilters } from "@/Utile/ncrmContactsAdvancedFilter.mjs";

const SORT_KEYS = Object.freeze({
  companies: ["name", "email", "phone", "category", "source", "createdAt", "privacy_state"],
  people: ["name", "company", "email", "phone", "source", "createdAt", "privacy_state"],
});

export const createDefaultContactsSortBy = () => [{ key: "createdAt", order: "desc" }];

export const contactListMixin = {
  methods: {
    resolveListSortState() {
      const first = Array.isArray(this.sortBy) && this.sortBy.length ? this.sortBy[0] : null;
      const key = String(first?.key || "").trim();
      const order = String(first?.order || "").trim().toLowerCase();
      if (!(SORT_KEYS[this.activeTab] || []).includes(key) || !["asc", "desc"].includes(order)) {
        return { key: "createdAt", order: "desc" };
      }
      return { key, order };
    },
    buildContactsQueryParams() {
      const search = String(this.search || "").trim();
      const sort = this.resolveListSortState();
      const filters = serializeContactsAdvancedFilters(this.advancedFilters);
      return {
        type: this.activeType, page: this.page, perPage: this.resolvePerPage(),
        search: search || undefined, sortBy: sort.key, sortOrder: sort.order,
        ...(filters ? { filters } : {}),
      };
    },
    mapPrivacySummary(row) {
      return {
        privacy_state: normalizePrivacyStatus(row?.privacy_state),
        privacy_breakdown: row?.privacy_breakdown ?? null,
        privacy_contact_points_total: row?.privacy_contact_points_total ?? null,
        privacy_contact_points_unclassified: row?.privacy_contact_points_unclassified ?? null,
        privacy_last_event_at: row?.privacy_last_event_at ?? null,
        privacy_updated_at: row?.privacy_updated_at ?? null,
      };
    },
    async fetchContacts() {
      this.tableLoading = true;
      try {
        const { data } = await axios.get("/ncrm/contacts", { params: this.buildContactsQueryParams() });
        const items = Array.isArray(data?.items) ? data.items : [];
        this.totalItems = Number.isFinite(Number(data?.total)) ? Number(data.total) : items.length;
        const shared = (row) => ({
          id: row.id, email: row.email_primary || "", phone: row.phone_primary || "",
          source: row.source || "", createdAt: this.formatDate(row.created_at),
          in_mailjet: Boolean(row.in_mailjet), last_call_at: row.last_call_at || "",
          last_call_has_pbx: Boolean(row.last_call_has_pbx), ...this.mapPrivacySummary(row),
        });
        if (this.activeType === "company") {
          this.companies = items.map((row) => ({
            ...shared(row), name: row.name, category: row.business_category || "",
          }));
          this.companyOptions = this.companies.map(({ name, id }) => ({ title: name, value: id }));
        } else {
          this.people = items.map((row) => ({
            ...shared(row),
            name: [row.first_name, row.last_name].filter(Boolean).join(" ").trim() || row.last_name,
            company: row.company_name || "",
          }));
        }
        this.retainVisibleContactSelection();
      } catch (error) {
        console.error("[ncrm] fetch contacts failed:", error);
        this.snackbar.message = this.$t("ncrm.contacts.loadError");
        this.snackbar.show = true;
      } finally {
        this.tableLoading = false;
      }
    },
  },
};
